import styled from 'styled-components';

import { Button, Typography } from '@mui/material';
import { wellzTheme } from '@wellz-theme/mui';
import { wellzTheme as theme } from 'theme';

export const Footer = styled.div`
  padding-left: ${wellzTheme.spacing(7)};
  padding-top: ${wellzTheme.spacing(2)};
  padding-bottom: ${wellzTheme.spacing(5)};
  display: flex;
  gap: ${wellzTheme.spacing(3)};

  ${wellzTheme.breakpoints.down('md')} {
    width: 100%;
    flex-direction: column;
    padding: ${wellzTheme.spacing(2.5)};
  }
`;

export const LinkText = styled(Typography)`
  color: ${theme.colors.inputDisabled};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const LinkBox = styled.div`
  padding: ${wellzTheme.spacing(0, 1.5)};
  height: ${wellzTheme.spacing(7)};
  border: ${wellzTheme.spacing(0.125)} solid ${theme.colors.moduleBorder};
  border-radius: ${wellzTheme.spacing(1)};
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0px;
`;

export const LinkAndButton = styled.div`
  padding: ${wellzTheme.spacing(2, 0)};
  display: flex;
  gap: ${wellzTheme.spacing(2)};
  align-items: center;
`;

export const Body = styled.div`
  padding: ${wellzTheme.spacing(2, 5)};
  flex: 1;

  ${wellzTheme.breakpoints.down('md')} {
    padding: ${wellzTheme.spacing(2.5)};
  }
`;

export const Header = styled.div`
  display: flex;
  padding: ${wellzTheme.spacing(2)};
  align-items: center;

  ${wellzTheme.breakpoints.down('md')} {
    width: 100%;
    margin: 0px;
    padding: ${wellzTheme.spacing(2.5)};
  }
`;

export const Container = styled.div`
  max-width: min(600px, 100vw);
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: white;
`;

export const SectionTitle = styled.p`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 1px;
  text-align: center;
  flex: 1;
  text-transform: uppercase;
`;

export const SimpleButton = styled(Button)`
  height: unset;
  min-width: unset;
`;
